import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ASPENDENTAL_COLOR, MOTTO_COLOR, MOTTO_V2_COLOR, WELLNOW_COLOR } from './constant'; // material ui theme palette definitions
// variable names must match with branding name provided in contentful

var motto = {
  brandName: 'motto',
  primary: {
    light: MOTTO_COLOR.primary[300],
    main: MOTTO_COLOR.primary[500],
    dark: MOTTO_COLOR.primary[700]
  },
  secondary: {
    light: MOTTO_COLOR.secondary[300],
    main: MOTTO_COLOR.secondary[500],
    dark: MOTTO_COLOR.secondary[700]
  },
  tertiary: {
    light: MOTTO_COLOR.tertiary[300],
    main: MOTTO_COLOR.tertiary[500],
    dark: MOTTO_COLOR.tertiary[700]
  },
  neutrals: {
    white: MOTTO_COLOR.neutrals.white,
    neutral: MOTTO_COLOR.neutrals[100],
    primary: MOTTO_COLOR.neutrals[300],
    disabled: MOTTO_COLOR.neutrals[700],
    secondary: MOTTO_COLOR.neutrals[900],
    tertiary: MOTTO_COLOR.neutrals[800]
  },
  text: {
    primary: MOTTO_COLOR.text.primary,
    secondary: MOTTO_COLOR.text.secondary,
    tertiary: MOTTO_COLOR.text.tertiary,
    light: MOTTO_COLOR.text.light,
    disabled: MOTTO_COLOR.text.disabled,
    link: MOTTO_COLOR.text.link,
    interactive: MOTTO_COLOR.text.link
  },
  accent01: {
    light: MOTTO_COLOR.accent01[300],
    main: MOTTO_COLOR.accent01[500],
    dark: MOTTO_COLOR.accent01[700]
  },
  success: {
    light: MOTTO_COLOR.success[300],
    main: MOTTO_COLOR.success[500],
    dark: MOTTO_COLOR.success[700]
  },
  error: {
    light: MOTTO_COLOR.error[300],
    main: MOTTO_COLOR.error[500],
    dark: MOTTO_COLOR.error[700]
  },
  warning: {
    light: MOTTO_COLOR.warning[300],
    main: MOTTO_COLOR.warning[500],
    dark: MOTTO_COLOR.warning[700]
  },
  info: {
    light: MOTTO_COLOR.info[300],
    main: MOTTO_COLOR.info[500],
    dark: MOTTO_COLOR.info[700]
  },
  backgrounds: _objectSpread({
    default: '#fff',
    paper: '#fff'
  }, MOTTO_COLOR.background)
};
var mottoV2 = {
  brandName: 'mottoV2',
  primary: {
    light: MOTTO_V2_COLOR.primary[300],
    mainLight: MOTTO_V2_COLOR.primary[400],
    main: MOTTO_V2_COLOR.primary[500],
    dark: MOTTO_V2_COLOR.primary[700]
  },
  secondary: {
    extraLight: MOTTO_V2_COLOR.secondary[100],
    light: MOTTO_V2_COLOR.secondary[300],
    main: MOTTO_V2_COLOR.secondary[500],
    mainDark: MOTTO_V2_COLOR.secondary[600],
    dark: MOTTO_V2_COLOR.secondary[700],
    extraDark: MOTTO_V2_COLOR.secondary[900]
  },
  neutrals: {
    white: MOTTO_V2_COLOR.neutrals.white,
    neutral: MOTTO_V2_COLOR.neutrals[100],
    primary: MOTTO_V2_COLOR.neutrals[300],
    disabled: MOTTO_V2_COLOR.neutrals[700],
    tertiary: MOTTO_V2_COLOR.neutrals[800],
    secondary: MOTTO_V2_COLOR.neutrals[900]
  },
  text: {
    light: MOTTO_V2_COLOR.text.white,
    primary: MOTTO_V2_COLOR.text.primary,
    secondary: MOTTO_V2_COLOR.text.secondary,
    link: MOTTO_V2_COLOR.text.link,
    disabledOnDark: MOTTO_V2_COLOR.text.disabledOnDark,
    disabledOnWhite: MOTTO_V2_COLOR.text.disabledOnWhite,
    disabled: MOTTO_V2_COLOR.text.disabled
  },
  accent01: {
    extraLight: MOTTO_V2_COLOR.accent01[100],
    light: MOTTO_V2_COLOR.accent01[300],
    main: MOTTO_V2_COLOR.accent01[500],
    dark: MOTTO_V2_COLOR.accent01[700],
    extraDark: MOTTO_V2_COLOR.accent01[900]
  },
  accent02: {
    extraLight: MOTTO_V2_COLOR.accent02[100],
    light: MOTTO_V2_COLOR.accent02[300],
    main: MOTTO_V2_COLOR.accent02[500],
    mainDark: MOTTO_V2_COLOR.accent02[600],
    dark: MOTTO_V2_COLOR.accent02[700],
    extraDark: MOTTO_V2_COLOR.accent02[900]
  },
  error: {
    light: MOTTO_V2_COLOR.error[300],
    main: MOTTO_V2_COLOR.error[500],
    dark: MOTTO_V2_COLOR.error[700]
  },
  info: {
    light: MOTTO_V2_COLOR.info[300],
    main: MOTTO_V2_COLOR.info[500],
    dark: MOTTO_V2_COLOR.info[700]
  },
  backgrounds: _objectSpread(_objectSpread({
    default: '#fff',
    paper: '#fff'
  }, MOTTO_V2_COLOR.solidBackground), MOTTO_V2_COLOR.gradientBackground)
};
var aspendental = {
  brandName: 'aspenDental',
  primary: {
    light: ASPENDENTAL_COLOR.primary[300],
    main: ASPENDENTAL_COLOR.primary[500],
    dark: ASPENDENTAL_COLOR.primary[700]
  },
  secondary: {
    light: ASPENDENTAL_COLOR.secondary[300],
    main: ASPENDENTAL_COLOR.secondary[500],
    dark: ASPENDENTAL_COLOR.secondary[700]
  },
  tertiary: {
    light: ASPENDENTAL_COLOR.tertiary[300],
    main: ASPENDENTAL_COLOR.tertiary[500],
    dark: ASPENDENTAL_COLOR.tertiary[700]
  },
  neutrals: {
    white: ASPENDENTAL_COLOR.neutrals.white,
    neutral: ASPENDENTAL_COLOR.neutrals[100],
    primary: ASPENDENTAL_COLOR.neutrals[300],
    disabled: ASPENDENTAL_COLOR.neutrals[700],
    secondary: ASPENDENTAL_COLOR.neutrals[900],
    tertiary: ASPENDENTAL_COLOR.neutrals[800]
  },
  text: {
    primary: ASPENDENTAL_COLOR.text.primary,
    secondary: ASPENDENTAL_COLOR.text.secondary,
    tertiary: ASPENDENTAL_COLOR.text.tertiary,
    light: ASPENDENTAL_COLOR.text.light,
    disabled: ASPENDENTAL_COLOR.text.disabled,
    link: ASPENDENTAL_COLOR.text.link,
    interactive: ASPENDENTAL_COLOR.text.link
  },
  accent01: {
    light: ASPENDENTAL_COLOR.accent01[300],
    main: ASPENDENTAL_COLOR.accent01[500],
    dark: ASPENDENTAL_COLOR.accent01[700]
  },
  success: {
    light: ASPENDENTAL_COLOR.success[300],
    main: ASPENDENTAL_COLOR.success[500],
    dark: ASPENDENTAL_COLOR.success[700]
  },
  error: {
    light: ASPENDENTAL_COLOR.error[300],
    main: ASPENDENTAL_COLOR.error[500],
    dark: ASPENDENTAL_COLOR.error[700]
  },
  warning: {
    light: ASPENDENTAL_COLOR.warning[300],
    main: ASPENDENTAL_COLOR.warning[500],
    dark: ASPENDENTAL_COLOR.warning[700]
  },
  info: {
    light: ASPENDENTAL_COLOR.info[300],
    main: ASPENDENTAL_COLOR.info[500],
    dark: ASPENDENTAL_COLOR.info[700]
  },
  backgrounds: _objectSpread({
    default: '#fff',
    paper: '#fff'
  }, ASPENDENTAL_COLOR.background)
};
var wellnow = {
  brandName: 'wellnow',
  primary: {
    light: WELLNOW_COLOR.primary[300],
    main: WELLNOW_COLOR.primary[500],
    dark: WELLNOW_COLOR.primary[700]
  },
  secondary: {
    light: WELLNOW_COLOR.secondary[300],
    main: WELLNOW_COLOR.secondary[500],
    dark: WELLNOW_COLOR.secondary[700]
  },
  tertiary: {
    light: WELLNOW_COLOR.tertiary[300],
    main: WELLNOW_COLOR.tertiary[500],
    dark: WELLNOW_COLOR.tertiary[700]
  },
  neutrals: {
    white: WELLNOW_COLOR.neutrals.white,
    neutral: WELLNOW_COLOR.neutrals[100],
    primary: WELLNOW_COLOR.neutrals[300],
    disabled: WELLNOW_COLOR.neutrals[700],
    secondary: WELLNOW_COLOR.neutrals[900],
    tertiary: WELLNOW_COLOR.neutrals[800]
  },
  text: {
    primary: WELLNOW_COLOR.text.primary,
    secondary: WELLNOW_COLOR.text.secondary,
    tertiary: WELLNOW_COLOR.text.tertiary,
    light: WELLNOW_COLOR.text.light,
    disabled: WELLNOW_COLOR.text.disabled,
    link: WELLNOW_COLOR.text.interactive,
    interactive: WELLNOW_COLOR.text.interactive
  },
  accent01: {
    light: WELLNOW_COLOR.accent01[300],
    main: WELLNOW_COLOR.accent01[500],
    dark: WELLNOW_COLOR.accent01[700]
  },
  accent02: {
    light: WELLNOW_COLOR.accent02[300],
    main: WELLNOW_COLOR.accent02[500],
    dark: WELLNOW_COLOR.accent02[700]
  },
  success: {
    light: WELLNOW_COLOR.success[300],
    main: WELLNOW_COLOR.success[500],
    dark: WELLNOW_COLOR.success[700]
  },
  error: {
    light: WELLNOW_COLOR.error[300],
    main: WELLNOW_COLOR.error[500],
    dark: WELLNOW_COLOR.error[700]
  },
  warning: {
    light: WELLNOW_COLOR.warning[300],
    main: WELLNOW_COLOR.warning[500],
    dark: WELLNOW_COLOR.warning[700]
  },
  info: {
    light: WELLNOW_COLOR.info[300],
    main: WELLNOW_COLOR.info[500],
    dark: WELLNOW_COLOR.info[700]
  },
  backgrounds: _objectSpread({
    default: '#fff',
    paper: '#fff'
  }, WELLNOW_COLOR.background)
};
export { aspendental, motto, mottoV2, wellnow };